import { HttpStatusCode } from "axios";
import IAward from "../models/award/IAward";
import networkService from "./NetworkService";

class AwardService {
    /**
     * @description Gets all awards
     */
    async getAwards(): Promise<IAward[]> {
        const result = await networkService.get<IAward[]>(`/portfolio/awards`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status !== HttpStatusCode.NoContent
            ? result.data as IAward[]
            : [];
    }

    /**
     * @description Gets the specified award
     * @param {string} id The ID of the award to be returned
     */
    async getAward(id: string): Promise<IAward> {
        const result = await networkService.get<IAward>(`/portfolio/award/${id}`);

        if (result.isSuccessful) {
            return result.data as IAward;
        }

        throw result.data;
    }

    /**
     * @description Creates a new award
     * @param {IAward} award The award data to be created
     */
    async createAward(award: IAward): Promise<IAward> {
        const result = await networkService.put<IAward, IAward>(`/portfolio/award`, award);

        if (result.isSuccessful) {
            return result.data as IAward;
        }

        throw result.data;
    }

    /**
     * @description Partially updates the specified award
     * @param {IAward} award The partial award data to be updated
     */
    async updateAward(award: IAward): Promise<IAward> {
        const result = await networkService.patch<IAward, IAward>(`/portfolio/award`, award);

        if (result.isSuccessful) {
            return result.data as IAward;
        }

        throw result.data;
    }

    /**
     * @description Deletes the specified award
     * @param {string} id The ID of the award to be deleted
     */
    async deleteAward(id: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/portfolio/award/${id}`);
        return result.isSuccessful;
    }
}

const awardService = new AwardService();
export default awardService; 